import { useState } from "react";

const categories = [
  "Data",
  "Design",
  "Product",
  "HR Management",
  "Project Management",
  "Cloud Computing",
  "Programming",
];

const BlogQuickFilter = ({ handleFetchCategoryData, count = 0 }) => {
  const [activeCategory, setActiveCategory] = useState(null);

  const handleClick = (category) => {
    setActiveCategory(category);
    handleFetchCategoryData(category);
  };

  const pillClass = (isActive) =>
    `flex-none whitespace-nowrap transition-colors ${
      isActive
        ? "bg-primary border-primary text-white"
        : "bg-white border-[#d8d7d1] text-[#555b68] hover:border-primary hover:text-primary"
    }`;

  return (
    <div
      className="sticky z-[12] backdrop-blur-[14px]"
      style={{
        background: "#fffdf8f5",
        border: "1px solid #e1ded5",
        borderRadius: "16px",
        marginBottom: "30px",
        padding: "22px 23px 19px",
        top: "calc(var(--header-height, 90px) + var(--subnav-height, 68px))",
        boxShadow: "0 13px 34px #2e271414",
      }}
    >
      <div className="flex justify-between items-end flex-wrap gap-[22px] mb-[17px]">
        <div>
          <p
            style={{
              color: "#8b5a00",
              letterSpacing: "0.1em",
              margin: "0 0 4px",
              fontSize: "15px",
              fontWeight: 800,
            }}
          >
            EXPLORE THE JOURNAL
          </p>
          <h2
            className="text-primary"
            style={{
              margin: 0,
              fontFamily: "Georgia, serif",
              fontSize: "clamp(29px, 3vw, 40px)",
              fontWeight: 600,
              lineHeight: 1.1,
            }}
          >
            Read by topic.
          </h2>
        </div>
        <span
          style={{
            color: "#744c00",
            background: "#fff0c7",
            borderRadius: "999px",
            padding: "8px 12px",
            fontSize: "15px",
            fontWeight: 800,
          }}
        >
          {count} article{count === 1 ? "" : "s"}
        </span>
      </div>

      <div
        className="flex gap-2 overflow-x-auto no-scrollbar"
        role="group"
        aria-label="Filter articles by topic"
      >
        <button
          type="button"
          onClick={() => handleClick(undefined)}
          aria-pressed={!activeCategory}
          className={pillClass(!activeCategory)}
          style={{
            border: "1px solid",
            borderRadius: "8px",
            minHeight: "42px",
            padding: "9px 14px",
            fontSize: "15px",
            fontWeight: 750,
          }}
        >
          All articles
        </button>
        {categories.map((category) => (
          <button
            key={category}
            type="button"
            onClick={() => handleClick(category)}
            aria-pressed={activeCategory === category}
            className={pillClass(activeCategory === category)}
            style={{
              border: "1px solid",
              borderRadius: "8px",
              minHeight: "42px",
              padding: "9px 14px",
              fontSize: "15px",
              fontWeight: 750,
            }}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
};

export default BlogQuickFilter;
